import {
  Button,
  ButtonGroup,
  ButtonIcon,
  Grow,
  Menu,
  Surface,
  useClickAwayListener,
  useMagnet,
} from '@mint/ui';
import React, { useCallback, useMemo, useState } from 'react';
import { AdminActionButtonContext } from './admin-action-button-context';
import { AdminActionButtonProps } from './admin-action-button-props';
import { WedgeDownIcon } from '@mint/icons';
import styled from 'styled-components';

const Div = styled.div`
  position: relative;
`;

export const AdminActionButton: React.FunctionComponent<
  AdminActionButtonProps
> = props => {
  const { color = 'primary', children, label, onClick } = props;
  const [actionsVisible, setActionsVisible] = useState(false);
  const [, style] = useMagnet({ anchor: 'north-east', position: 'inside' });

  const ref = useClickAwayListener((): void => setActionsVisible(false), {
    enabled: actionsVisible,
  });

  const openDropdown = useCallback(() => {
    setActionsVisible(true);
  }, []);

  const closeDropdown = useCallback(() => {
    setActionsVisible(false);
  }, []);

  const context = useMemo(
    () => ({
      close: closeDropdown,
      open: openDropdown,
    }),
    [openDropdown, closeDropdown],
  );

  return (
    <Div ref={ref}>
      <ButtonGroup>
        <Button onClick={onClick} variant="raised" color={color}>
          {label}
        </Button>
        {children && (
          <Button variant="raised" color={color} onClick={openDropdown}>
            <ButtonIcon>
              <WedgeDownIcon />
            </ButtonIcon>
          </Button>
        )}
      </ButtonGroup>
      {children && (
        <Grow
          onClick={closeDropdown}
          in={actionsVisible}
          style={{
            ...style,
            transform: 'rotate3d(0)',
            transformOrigin: 'top right',
            position: 'absolute',
            zIndex: 1000,
            whiteSpace: 'nowrap',
          }}
        >
          <Surface z={8}>
            <AdminActionButtonContext.Provider value={context}>
              <Menu>{children}</Menu>
            </AdminActionButtonContext.Provider>
          </Surface>
        </Grow>
      )}
    </Div>
  );
};
